module.exports = __webpack_public_path__ + "img/e_2_18_g.221cb233.png";